import createCardListingView from '../Views/createCardListingView';
import FlexVideoCard from './FlexVideoCard';

export default createCardListingView(FlexVideoCard, {
  displayName: 'VideoListingView',
});
